import React, { memo } from 'react';

import Icon from 'components/Icon';
import { SelectIcons } from './styles';
import IconTypes from '../Icon/IconTypes';
import { LoadingCircleIndicatorNoPad } from '../LoadingCircleIndicator/LoadingCircleIndicator';

interface IComponentProps {
  showRemoveIcon: boolean;
  onRemoveValues: () => void;
  dropDownIconClick?: () => void;
  iconOverride?: IconTypes;
  isLoading?: boolean;
}

const SelectActionsIcon: React.FC<IComponentProps> = ({
  onRemoveValues,
  showRemoveIcon,
  iconOverride,
  dropDownIconClick,
  isLoading,
}) => (
  <SelectIcons>
    {isLoading && (
      <div>
        <LoadingCircleIndicatorNoPad
          innerStyle={{
            width: '16px',
            height: '16px',
          }}
        />
      </div>
    )}
    {showRemoveIcon && (
      <React.Fragment>
        <Icon type="x" onClick={onRemoveValues} />
        <span>|</span>
      </React.Fragment>
    )}
    <Icon type={iconOverride || 'chevron-down'} onClick={dropDownIconClick} />
  </SelectIcons>
);

export default memo(SelectActionsIcon);
